import { Component, Input, OnInit } from '@angular/core';
import { PageService } from '../../../services/page.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ChapterService } from '../../../services/chapter.service';
import { RealPageNumberPipe } from '../../../pipes/real-page-number.pipe';

@Component({
    selector: 'app-main-chapter-heading',
    templateUrl: './main-chapter-heading.component.html',
    styleUrls: ['./main-chapter-heading.component.scss'],
    standalone: true,
    imports: [
        RealPageNumberPipe
    ]
})
export class MainChapterHeadingComponent implements OnInit {

    @Input() chapter;
    realPageNumber: number;
    showChapterNames: boolean;
    chapterHierarchyMap: Map<number, Array<string | number>> = new Map<number, Array<string | number>>();
    hierachy: string;
    hierachyContainsChapter: boolean;

    constructor(private pageService: PageService,
                private chapterService: ChapterService,
                private applicationStateService: ApplicationStateService) {
    }

    ngOnInit(): void {
        this.getHierarchy();
    }

    getHierarchyToShow(): string {

        if (this.chapter.title === 'Alle Seiten') {
            return '1';
        }

        return this.chapterHierarchyMap.get(this.chapter.id).join('.');
    }

    getHierarchy(): void {
        this.chapterService.getChapterHierarchyFromChapter(this.chapter).then(result => {
            this.chapterHierarchyMap.set(this.chapter.id, result);
            this.showChapterNames = this.applicationStateService.bookConfig.chaptersOrderEnabled;
            this.realPageNumber = this.pageService.getRealPageNumber(this.chapter.index);
            this.hierachy = this.getHierarchyToShow();
            this.hierachyContainsChapter = this.chapterHierarchyMap.has(this.chapter.id);
        });
    }
}
